export interface Logo {
  uuid: string;
  moduleFor: string;
  moduleUuid: string;
  url: string;
  isPrimary: boolean;
  dateCreated?: Date | null;
  dateUpdated: Date | null;
  dateDisabled: Date | null;
  createdByUuid: string;
  updatedByUuid: string | null;
}

export interface TeamLeagueDto {
  uuid: string;
  title: string;
  playerCount: number;
  isFavourite: boolean;
  logo: Logo;
  startDatetime: string;
  endDatetime: string;
  location: LocationDto | null;
  distance: number;
  organizationUuid: string;
  isSeasonActive: boolean;
  slug: string;
  seasonStandingsExist: boolean;
}

interface StateInfoDto {
  id: string;
  abbreviation: string;
  title: string;
  countryId: number;
  isEnabled: boolean;
}

interface CountryInfoDto {
  abbreviation: string;
  id: string;
  internationalCountryCallingCode: string;
  title: string;
  stateTitle: string;
  zipCodeTitle: string;
  systemTextNumberId: string;
  abbreviation2Digit: string;
  displayOrder: string;
  isEnabled: boolean;
  regionType: string;
}

interface LocationDto {
  uuid: string;
  uuidCopiedFrom: string;
  moduleFor: number;
  moduleUuid: string;
  surfaceTypeId: number;
  playAreaTypeId: number;
  netTypeId: number;
  isPrimary: boolean;
  venue: string;
  altName: string;
  streetAddress: string;
  countryId: number;
  stateId: number;
  city: string;
  zip: string;
  ballUsed: string;
  ballUrl: string;
  parkingInformation: string;
  isParkingFee: boolean;
  numberOfCourts: number;
  latitude: number;
  longitude: number;
  dateCreated: string;
  createdByFullName: string;
  dateUpdated: string | null;
  updatedByFullName: string;
  dateDisabled: string | null;
  disabledByFullName: string;
  usePrintSpooler: boolean;
  locationIdInt: string;
  geniusSportsCourts: boolean;
  venueGeniusId: string;
  dateApproved: string | null;
  description: string;
  email: string;
  isFeeToPay: boolean;
  isLight: boolean;
  isOpenPlay: boolean;
  numberOfCourtsIndoor: string;
  numberOfCourtsOutdoor: string;
  phone: string;
  phoneAreaCode: string;
  phoneCountryId: string;
  url: string;
  lighting: boolean;
  facilityCategory: number;
  stateInfo: StateInfoDto;
  countryInfo: CountryInfoDto;
  createdByUuid: string | null;
  updatedByUuid: string | null;
}

export enum TeamLeagueTypes {
  Managing = 'Manage',
  RegisteredFor = 'RegisteredFor',
  Favorited = 'Favorite',
}

export const teamLeagueTypeMap: Record<string, TeamLeagueTypes> = {
  registeredfor: TeamLeagueTypes.RegisteredFor,
  manage: TeamLeagueTypes.Managing,
  favorites: TeamLeagueTypes.Favorited,
};

export enum TeamLeagueStatus {
  Future = 'active',
  Past = 'past',
}

export const statusMap: Record<string, TeamLeagueStatus> = {
  future: TeamLeagueStatus.Future,
  past: TeamLeagueStatus.Past,
};
